module.exports = __webpack_public_path__ + "static/Karim-c0c7b6c3b9f4559b67e5a1b2da702479.jpg";